<template>
  <div class="w-full h-full bg-primary2">
    <div class="maxwidthscreen w-full h-full flex mx-auto">
      <!-- Left Navigation -->

      <LeftNavigation currentTap="application" />

      <div
        class="containerHead w-full flex flex-col gap-4 max-h-screen overflow-y-auto lg:py-6"
      >
        <div
          class="w-full h-[80px] bg-primary2 p-4 shadow-lg flex justify-between items-center gap-5 sticky top-0 z-50 md:hidden"
        >
          <div class="visible md:invisible">
            <img :src="logo" class="w-[100px]" />
          </div>
          <div class="flex items-center justify-end">
            <button
              class="block md:hidden px-3 text-black"
              type="button"
              id="navBarIcon"
            >
              <i class="fa-solid fa-bars text-3xl"></i>
            </button>
          </div>
        </div>
        <div class="w-full h-full p-3 lg:p-5">
          <h2 class="text-left text-xl lg:text-3xl text-black font-bold">
            Application Form
          </h2>
          <div class="pt-3 lg:pt-6 flex flex-col gap-3 lg:gap-6">
            <div></div>
            <div class="flex flex-col gap-3 lg:gap-5">
              <div
                v-for="(el, index) in formList"
                :key="index"
                @click="toggleForm(el)"
                :class="{
                  'bg-gray-200 font-bold text-2xl border': activeForm === el,
                  'bg-gray-100': activeForm !== el,
                }"
                class="dark_text flex flex-col gap-3 text-left cursor-pointer rounded-md"
              >
                <div
                  class="flex justify-between items-center capitalize px-5 py-5"
                >
                  <h2
                    class="cursor-pointer text-xl lg:text-3xl"
                    :class="{
                      'text-primary': activeForm === el,
                      dark_text: activeForm !== el,
                    }"
                  >
                    {{ el }}
                  </h2>
                  <div class="flex gap-3 lg:gap-6">
                    <!-- <span class="text-sm p-1 border bg-primary text rounded-md">Step : {{index+1}}/6</span> -->
                    <img
                      v-if="activeForm === el"
                      :src="angle_down"
                      alt="down-arrow"
                      class="down-arrow rotate-180 w-4 h-4 object-contain"
                    />
                    <img
                      v-if="activeForm !== el"
                      :src="angle_down"
                      alt="down-arrow"
                      class="down-arrow w-4 h-4 object-contain"
                    />
                  </div>
                </div>

                <!-- Form content for "basic" -->
                <div
                  v-if="
                    activeForm === 'basic information' &&
                    el === 'basic information'
                  "
                  id="basic information"
                >
                  <BasicView
                    :complete_status="overall_complete"
                    @formCompleted="onFormCompleted()"
                  />
                </div>

                <div
                  v-if="
                    activeForm === 'additional information' &&
                    el === 'additional information'
                  "
                  id="additional information"
                >
                  <AdditionalView
                    :complete_status="overall_complete"
                    @formCompleted="onFormCompleted()"
                  />
                </div>

                <!-- Form content for "payment" -->
                <div
                  v-if="
                    activeForm === 'payment information' &&
                    el === 'payment information'
                  "
                  id="payment information"
                >
                  <PaymentView
                    :complete_status="overall_complete"
                    @formCompleted="onFormCompleted()"
                  />
                </div>
                <div
                  v-if="
                    activeForm === 'education & work experience' &&
                    el === 'education & work experience'
                  "
                  id="education & work experience"
                >
                  <!-- <EducationView :complete_status="overall_complete" @formCompleted="onFormCompleted('education & work experience')"/> -->
                  <EducationView
                    :complete_status="overall_complete"
                    @formCompleted="onFormCompleted()"
                  />
                </div>
                <div
                  v-if="
                    activeForm === 'document upload' && el === 'document upload'
                  "
                  id="document upload"
                >
                  <!-- <DocumentsView @form_status="receiveEmit" @formCompleted="onFormCompleted('document upload')"/> -->
                  <DocumentsView @formCompleted="onFormCompleted()" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LeftNavigation from "@/components/leftNavigation.vue";
import axios from "axios";
import PaymentView from "@/components/Application/PaymentView.vue";
import BasicView from "@/components/Application/BasicView.vue";
import AdditionalView from "@/components/Application/AdditionalView.vue";
import EducationView from "@/components/Application/EducationView.vue";
import DocumentsView from "@/components/Application/DocumentsView.vue";
export default {
  data() {
    return {
      angle_down: require(`${process.env.VUE_APP_ANGLE_DOWN}`),
      logo: require(`${process.env.VUE_APP_LOGO}`),
      formList: [
        "basic information",
        "additional information",
        "payment information",
        "education & work experience",
        "document upload",
      ],
      // activeForm: null,

      activeForm: "basic information",
      completedForms: [],
      overall_complete: "",
      get_oraginzation: [],
      basic_status: false,
      additional_status: false,
      payment_status: false,
      education_status: false,
      document_status: false,
    };
  },
  components: {
    LeftNavigation,
    BasicView,
    PaymentView,
    AdditionalView,
    EducationView,
    DocumentsView,
  },
  computed: {
    ...mapGetters(["userInfo", "isAuthenticated"]),
  },

  async created() {
    this.fetchOrganization();
  },

  mounted() {
    $("#navBarIcon").on("click", function () {
      $("#navbarContainer").toggleClass("open");
    });
  },
  methods: {
    ...mapActions(["logOutUser"]),
    async fetchOrganization() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/organization-overall-list/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.status === 200) {
            this.get_oraginzation = resp.data.data;
            console.log("this.get_oraginzation", this.get_oraginzation);
            if (resp.data.data != null) {
              this.overall_complete = resp.data.data[0].is_form_completed;
            }

            if (this.get_oraginzation[0].basic_information != null) {
              this.basic_status =
                this.get_oraginzation[0].basic_information.is_form_one_filled;
            } else {
              this.basic_status = false;
            }

            if (this.get_oraginzation[0].payment_details != null) {
              this.payment_status =
                this.get_oraginzation[0].payment_details.is_paid;
            } else {
              this.payment_status = false;
            }
            if (this.get_oraginzation[0].additional_information != null) {
              this.additional_status =
                this.get_oraginzation[0].additional_information.is_form_two_filled;
            } else {
              this.additional_status = false;
            }
            if (this.get_oraginzation[0].documents_upload != null) {
              this.document_status =
                this.get_oraginzation[0].documents_upload.is_form_three_filled;
            } else {
              this.document_status = false;
            }
            if (this.get_oraginzation != null) {
              this.education_status =
                this.get_oraginzation[0].is_form_five_filled;
            } else {
              this.education_status = false;
            }
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },

    onFormCompleted() {
      this.fetchOrganization();
    },
    toggleForm(formName) {
      this.activeForm = this.activeForm === formName ? null : formName;
    },

    // toggleForm(formName) {
    //   if (this.basic_status && this.additional_status == false) {
    //     if (formName === "basic information") {
    //       this.activeForm = "basic information";
    //     } else if (formName === "additional information") {
    //       this.activeForm = "additional information";
    //     }
    //   } else if (
    //     this.basic_status &&
    //     this.additional_status &&
    //     this.payment_status == false
    //   ) {
    //     if (formName === "basic information") {
    //       this.activeForm = "basic information";
    //     } else if (formName === "additional information") {
    //       this.activeForm = "additional information";
    //     } else if (formName === "payment information") {
    //       this.activeForm = "payment information";
    //     }
    //   } else if (
    //     this.basic_status &&
    //     this.additional_status &&
    //     this.payment_status &&
    //     this.education_status == false
    //   ) {
    //     if (formName === "basic information") {
    //       this.activeForm = "basic information";
    //     } else if (formName === "additional information") {
    //       this.activeForm = "additional information";
    //     } else if (formName === "payment information") {
    //       this.activeForm = "payment information";
    //     } else if (formName === "education & work experience") {
    //       this.activeForm = "education & work experience";
    //     }
    //   } else if (
    //     this.basic_status &&
    //     this.additional_status &&
    //     this.payment_status &&
    //     this.education_status &&
    //     this.document_status == false
    //   ) {
    //     this.activeForm = this.activeForm === formName ? null : formName;
    //   } else if (
    //     this.basic_status &&
    //     this.additional_status &&
    //     this.payment_status &&
    //     this.education_status &&
    //     this.document_status
    //   ) {
    //     this.activeForm = this.activeForm === formName ? null : formName;
    //   }
    //   // this.$nextTick(() => {
    //   //   setTimeout(() => {
    //   //     const element = document.getElementById(formName);
    //   //     if (element) {
    //   //       element.scrollIntoView({ behavior: "smooth" });
    //   //     }
    //   //   }, 1000);
    //   // });
    // },
    sessionStoreUn(val) {
      sessionStorage.setItem("slt_uni", val);
    },
    receiveEmit(status) {
      this.overall_complete = status;
      console.log("status", status);
    },

    async logOut() {
      await this.logOutUser();
      if (this.isAuthenticated == false) {
        this.$router.push({ name: "Login" });
      }
    },
  },
};
</script>

<style scoped>
.selectOptions::after {
  content: "";
  position: absolute;
  bottom: -17px;
  right: 48%;
  border-top: 27px solid #2563eb;
  border-left: 17px solid transparent;
  border-right: 17px solid transparent;
}
label {
  color: #4b5563;
}
</style>
